export const dimensionMaxCharacter = 255;
